module.exports = "/hub/_next/static/assets/2f29d00271b9ecd41b96dd0673939fed.svg";